import { useForm } from 'react-hook-form'
import { zodResolver } from '@hookform/resolvers/zod'
import { useState } from 'react'

import { cepService } from '@/app/services/cepService'
import { useBanks } from '@/app/hooks/useBanks'
import { CreditClientFormData, formSchema } from './components/schema'
import useCreditSellerCardController from '../CreditSellerCard/useCreditSellerCardController'

export const useCreditClientFormController = () => {
  const [step, setStep] = useState(0)
  const { seller, handleWhatsAppClick } = useCreditSellerCardController()

  const form = useForm<CreditClientFormData>({
    resolver: zodResolver(formSchema),
    mode: 'onChange',
    defaultValues: {
      personalInfo: {
        email: '',
        phone: '',
        rg: {
          number: '',
          date: '',
          uf: '',
          org: '',
        },
      },
      address: {
        zipCode: '',
        street: '',
        number: '',
        complement: '',
        neighborhood: '',
        city: '',
        state: '',
      },
      bankAccount: {
        bank: '',
        agency: '',
        account: '',
        accountType: 'CC',
      },
    },
  })

  const { data } = useBanks({ allBanks: false })

  const banks = data?.banks || []

  const handleNextStep = () => {
    if (step < 3) {
      setStep(step + 1)
    }
  }

  const handlePrevStep = () => {
    if (step > 0) {
      setStep(step - 1)
    }
  }

  const handleCepRequest = async (cep: string) => {
    try {
      const response = await cepService(cep.replace(/\D/g, ''))
      if (response) {
        form.setValue('address.street', response.logradouro)
        form.setValue('address.neighborhood', response.bairro)
        form.setValue('address.city', response.localidade)
        form.setValue('address.state', response.uf)
        form.setValue('address.complement', response.complemento)

        form.clearErrors([
          'address.street',
          'address.neighborhood',
          'address.city',
          'address.state',
        ])

        await form.trigger([
          'address.street',
          'address.neighborhood',
          'address.city',
          'address.state',
          'address.number',
        ])
      }
    } catch (error) {
      console.error('Erro ao buscar CEP:', error)
    }
  }

  const steps = {
    personalInfo: step === 0,
    address: step === 1,
    bankInfo: step === 2,
    review: step === 3,
  }

  return {
    form,
    step,
    steps,
    banks,
    handleNextStep,
    handlePrevStep,
    handleCepRequest,
    seller,
    handleWhatsAppClick,
  }
}
